var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"busTraffic"},[_c('h2',[_vm._v(_vm._s(_vm.$t('traffic_type['+_vm.type+']')))]),_vm._l((_vm.busTraffic_route),function(n,i){return _c('trafficRoute',{key:i,attrs:{"traffic_route":n}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }